import { render, staticRenderFns } from "./RelatorioPedidoMedias.vue?vue&type=template&id=8cba962e"
import script from "./RelatorioPedidoMedias.vue?vue&type=script&lang=js"
export * from "./RelatorioPedidoMedias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports